import { convertNodeSchema, Node, nodeSchema, NodeSchema } from "@/lib/types/node"
import { Button, Group, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { zod4Resolver } from "mantine-form-zod-resolver";

type Props = {
  node?: Node,
  onSubmit: (node: NodeSchema) => void,
  close: () => void
}

export const NodeForm = ({ node: initialNode, onSubmit, close }: Props) => {
  const form = useForm<NodeSchema>({
    initialValues: initialNode ? convertNodeSchema(initialNode) : {
      name: "",
    },
    validate: zod4Resolver(nodeSchema),
  })

  const handleSubmit = async () => {
    if (form.validate().hasErrors) return

    onSubmit(form.values)
  }

  return (
    <Stack>
      <TextInput
        label="Name"
        placeholder="Pi 2"
        {...form.getInputProps("name")}
      />
      <Group justify="end">
        <Button onClick={close} variant="outline">
          Cancel
        </Button>
        <Button onClick={handleSubmit}>
          Submit
        </Button>
      </Group>
    </Stack>
  )
}
